/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

export const acknowledgePublishError = createAction("ACKNOWLEDGE_PUBLISH_ERROR");
export const acknowledgePublishSuccess = createAction("ACKNOWLEDGE_PUBLISH_SUCCESS");

export const sendDiagnosticDataActions = createAsyncAction(
  "SEND_DIAGNOSTIC_DATA_REQUEST",
  "SEND_DIAGNOSTIC_DATA_SUCCESS",
  "SEND_DIAGNOSTIC_DATA_FAILURE"
)<string, string, Error>();

export type PublishUIActions =
  | ActionType<typeof acknowledgePublishError>
  | ActionType<typeof acknowledgePublishSuccess>;
export type InterfaceActions = PublishUIActions | ActionType<typeof sendDiagnosticDataActions>;
